var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbsUp = function SvgThumbsUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.08 26H8.033c-.539 0-1.056-.21-1.437-.586A1.98 1.98 0 0 1 6 24v-7c0-.53.214-1.04.595-1.414A2.05 2.05 0 0 1 8.032 15h3.049m7.113-2V9c0-.796-.322-1.559-.893-2.121A3.07 3.07 0 0 0 15.145 6l-4.064 9v11h11.462c.49.005.965-.164 1.339-.476.373-.312.62-.747.693-1.224l1.402-9a1.97 1.97 0 0 0-.476-1.613 2 2 0 0 0-.701-.512 2.1 2.1 0 0 0-.855-.175z"
  })));
};
export default SvgThumbsUp;